import styled from 'styled-components';
import { animated } from 'react-spring';

import { breakpoints, spacing } from '../../constants';

export const SliderWrapper = styled(animated.div)`
    min-height: 50px;
    display: flex;
    align-items: center;
    margin-top: ${spacing.md};
    width: 100%;
    max-width: 400px;
`;
